import axios from "../../axios"

const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer "+ token
    }
  }
}
export default {
    async getAllLoginFailuresReport(startAt, finishAt, selectedUsers) {
      axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/dashboard-report';
      try {
        let reports = await axios.post('', {
          ...header(),
          params: {
            start_at: startAt,
            finish_at: finishAt,
            selectedUsers: selectedUsers
          }
        });
        return reports.data;
      } catch (error) {
        console.error('Erro na requisição:', error);
        return [];
      }
    },
    
}